import { HttpError, useOne } from "@refinedev/core";
import { PendingPaymentTable } from "./table";
import { PendingPaymentCard } from "./card";

export const PendingPayment = ({currentFilterValues}: {currentFilterValues: any}) => {
  const { data: pendingPaymentData, isLoading: isLoadingPendingPayment } = useOne<any[], HttpError>({
    resource: "dashboard/event",
    id: `${currentFilterValues.event_id}/pending-payment`,
    meta: {
      resource: "data",
      filters: [
        {
          field: "from_date",
          operator: "eq",
          value: currentFilterValues?.from_date ?? ""
        },
        {
          field: "to_date",
          operator: "eq",
          value: currentFilterValues?.to_date ?? ""
        },
        {
          field: "ticket_platform",
          operator: "eq",
          value: currentFilterValues?.ticket_platform ?? ""
        },
        {
          field: "currency",
          operator: "eq",
          value: localStorage.getItem("currency") ?? ""
        },
        {
          field: "gateway_owner",
          operator: "eq",
          value: currentFilterValues?.gateway_owner ?? ""
        },
        {
          field: "gateway_partner_code",
          operator: "eq",
          value: currentFilterValues?.gateway_partner_code ?? ""
        },
        {
          field: "gateway_name",
          operator: "eq",
          value: currentFilterValues?.gateway_name ?? ""
        },
      ]
    },
    queryOptions: {
      enabled: !!currentFilterValues
    } as any,
  });

  return (
    <div className="box-container">
      <div className="sm:hidden">
        <PendingPaymentCard 
          data={pendingPaymentData?.data}
          isLoading={isLoadingPendingPayment}
        />
      </div>
      <div className="hidden sm:block">
        <PendingPaymentTable
          data={pendingPaymentData?.data}
          isLoading={isLoadingPendingPayment}
        />
      </div>
    </div>
  )
}